import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";
import SettingsIcon from "@material-ui/icons/Settings";
import IconButton from "@material-ui/core/IconButton";
import Modal from "@material-ui/core/Modal";
import Fade from "@material-ui/core/Fade";

import NativeSelect from "@meetyoo/components/src/components/Selects/NativeSelect";

import { setLanguage } from "../../../actions/ui";

const useStyles = makeStyles(theme => ({
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export const AppbarSettingsComponent = ({ translate, language, setLanguageFn }) => {
  const [openSettings, setOpenSettings] = useState(false);

  const classes = useStyles();
  return [
    <Modal key="settings" className={classes.modal} open={openSettings} onClose={() => setOpenSettings(false)}>
      <Fade in={openSettings} className={classes.paper}>
        <div>
          <h2>{translate.settings}</h2>
          <NativeSelect
            value={translate.language}
            currentSelect={language}
            selectValues={["en", "de"]}
            onChange={e => setLanguageFn(e.target.value)}
          />
          <div>version: 17042025</div>
        </div>
      </Fade>
    </Modal>,
    <IconButton
      key="settingsButton"
      aria-label="Settings for current user"
      aria-controls="settings-appbar"
      aria-haspopup="true"
      onClick={() => setOpenSettings(true)}
      color="inherit"
    >
      <SettingsIcon />
    </IconButton>,
  ];
};

AppbarSettingsComponent.propTypes = {
  setLanguageFn: PropTypes.func.isRequired,
  translate: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
};

const mapStateToProps = state => ({ translate: state.ui.translate, language: state.ui.language });

const mapDispatchToProps = dispatch => ({
  setLanguageFn: language => dispatch(setLanguage(language)),
});

const AppbarSettings = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppbarSettingsComponent);

export default AppbarSettings;
